<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading">
    <p class="font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-white dark:bg-black ">Price List</p>

    <div class="w-full overflow-x-auto px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-l">
        <div class="flex flex-row items-center justify-between">
            <div class="flex flex-col justify-between">
                <p class="font-semibold text-lg mb-1 dark:text-white">Market Price on {{today}}</p>
                <p *ngIf="hasData" class="text-[#636D81] dark:text-[#D1D1D1]">
                    Last upload at {{ priceListArr[0].createdAt | date: 'hh:mm a' }} on {{ priceListArr[0].createdAt |
                    date: 'yyyy/MM/dd' }}
                </p>
            </div>
            <div class="flex flex-row items-center gap-8 ">
                <i class="fa-solid fa-list text-[#4A4A4A] text-lg dark:text-white"></i>

                <p class="text-[#4A4A4A] dark:text-white">Filter By</p>
                <div class="relative w-36 custom-grade-dropdown-container">
                    <!-- Hidden native select -->
                    <select [(ngModel)]="selectGrade" class="hidden" (change)="filterGrade()">
                        <option
                                class=" dark:bg-[#292929] text-textLight dark:text-white hover:bg-gray-300 dark:hover:bg-[#292929]"
                                value="A">A</option>
                            <option
                                class=" dark:bg-[#292929] text-textLight dark:text-white hover:bg-gray-300 dark:hover:bg-[#292929]"
                                value="B">B</option>
                            <option
                                class=" dark:bg-[#292929] text-textLight dark:text-white hover:bg-gray-300 dark:hover:bg-[#292929]"
                                value="C">C</option>
                    </select>

                    <!-- Custom dropdown trigger -->
                    <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                        (click)="toggleGradeDropdown()">
                        <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer ">
                            <span>{{ selectGrade || 'Grade' }}</span>
                            <div class="flex items-center ">
                                <!-- X icon (shown ONLY when option is selected) -->
                                <i *ngIf="selectGrade" (click)="cancelGrade($event)"
                                    class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                                <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                                <i *ngIf="isGradeDropdownOpen || !selectGrade"
                                    class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                    [class.fa-angle-down]="!isGradeDropdownOpen"
                                    [class.fa-angle-up]="isGradeDropdownOpen"></i>
                            </div>
                        </div>
                    </div>

                    <!-- Custom dropdown options -->
                    <div *ngIf="isGradeDropdownOpen"
                        class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                        <div class="">
                            <div *ngFor="let option of gradeDropdownOptions; let i = index" (click)="selectGradeOption(option)"
                                class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center"
                                [ngClass]="{
                                    'rounded-t-xl': i === 0,
                                    'rounded-b-xl': i === gradeDropdownOptions.length - 1
                                  }">
                                <span class="flex-grow">{{ option }}</span>
                                <i
                                    class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="flex mr-5 items-center rounded-full  px-4 py-2 w-96 bg-[#F1F1F1] dark:bg-[#292929]">
                    <input type="text" placeholder="Search by Crop / Variety name.." [(ngModel)]="searchText" (keyup.enter)="onSearch()" (keyup.esc)="offSearch()"
                        class="bg-transparent outline-none w-full text-textLight dark:text-textDark " />
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                        (click)="onSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                        </svg>
                    </button>
                    <button *ngIf="searchText" type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                        (click)="offSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

            </div>

        </div>

        <div *ngIf="!hasData"
            class="flex flex-col items-center w-full h-screen px-10 py-7 mt-6 ">
            <p class="text-[#494949] my-6 dark:text-textDark">--No Data Availabale--</p>
            <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
        </div>

        <div *ngIf="hasData" class="min-w-max mt-8 mr-5 border-gray-100 border-[2px] rounded-lg dark:border-[#202021]">
            <table class="w-full min-w-max divide-y-2 overflow-hidden ">
                <thead class=" text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021]">
                    <tr>
                        <th class=" px-6 py-3 text-left text-sm font-medium">No</th>
                        <th class=" px-6 py-3 text-left text-sm font-medium">Crop Name</th>
                        <th class=" px-6 py-3 text-left text-sm font-medium">Variety Name</th>
                        <th class=" px-6 py-3 text-center text-sm font-medium">Grade</th>
                        <th class=" px-6 py-3 text-center text-sm font-medium">Indicate Price (Rs.)</th>
                        <th class=" px-6 py-3 text-center text-sm font-medium">Average Price (Rs.)</th>
                        <th class=" px-6 py-3 text-center text-sm font-medium">Centre Price (Rs.)</th>
                        <th class=" px-6 py-3 text-center text-sm font-medium"></th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                    <tr
                        *ngFor="let item of priceListArr | paginate : { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems }; let i = index">
                        <td class="px-6 py-4 text-sm text-gray-900 dark:text-[#C5C5C5]">
                            {{ (((page - 1) * itemsPerPage) + i + 1) < 10 ? '0' + (((page - 1) * itemsPerPage) + i + 1)
                                : (((page - 1) * itemsPerPage) + i + 1) }} </td>
                        <td class="px-6 py-4 text-sm text-gray-900 dark:text-[#C5C5C5]">{{ item.cropNameEnglish }}</td>
                        <td class="px-6 py-4 text-sm text-gray-900 dark:text-[#C5C5C5]">{{ item.varietyNameEnglish }}
                        </td>
                        <td class="px-6 py-4 text-sm text-center text-gray-900 dark:text-[#C5C5C5]">{{ item.grade }}</td>
                        <td class="px-6 py-4 text-sm text-center text-gray-900 dark:text-[#C5C5C5]">{{ item.indicatePrice }}</td>
                        <td class="px-6 py-4 text-sm text-center text-gray-900 dark:text-[#C5C5C5]">{{ item.averagePrice }}</td>
                        <td class="px-6 py-4 text-sm text-center text-gray-900 dark:text-[#C5C5C5]">
                            <span *ngIf="editingIndex !== i">
                                {{ item.updatedPrice }}
                            </span>
                            <span *ngIf="editingIndex === i">
                                <input type="number" [(ngModel)]="editValue" (input)="validateInput()"
                                    class="border-[#415CFF] dark:text-black border-[2px] border-dotted rounded-lg w-20 px-2 py-1"
                                    min="0" step="0.01" required />
                                <div *ngIf="!isUpdateAllowed" class="text-red-600 mt-1 text-right">
                                    {{rangeValidationMassage}}
                                </div>

                            </span>
                        </td>
                        <td class="px-6 py-4 flex justify-center space-x-4">
                            <button *ngIf="editingIndex !== i" class="text-[#415CFF] hover:text-blue-500"
                                (click)="editRow(i, item.updatedPrice)">
                                <i class="fa-solid fa-pen-to-square text-lg"></i>
                            </button>
                            <button *ngIf="editingIndex === i" 
                                [ngClass]="{
                                'bg-[#415CFF] text-white hover:text-blue-100': !isInvalidInput() && isUpdateAllowed,
                                'bg-gray-400 text-gray-200 cursor-not-allowed': isInvalidInput() || !isUpdateAllowed
                                }" 
                                class="px-2 py-1 rounded-lg" [disabled]="isInvalidInput() || !isUpdateAllowed"
                                (click)="saveRow(item.id, item.cropNameEnglish, item.grade, item.varietyNameEnglish)">
                                Save
                            </button>
                        </td>
                    </tr>
                </tbody>

            </table>
        </div>
        <div class="flex justify-end items-center my-5 mr-5 pt-3 dark:bg-[#1D1D1F] text-right">
            <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true" [previousLabel]="'Previous'"
                [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'" [screenReaderPageLabel]="'page'"
                [screenReaderCurrentLabel]="'Youre on page'">
            </pagination-controls>
        </div>
    </div>
</div>



<div *ngIf="isExit" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="flex flex-col justify-center items-center gap-y-5 bg-white dark:bg-[#363636] shadow-lg rounded-lg p-6 w-1/3">
        <div class="flex items-center justify-center bg-[#F6F7F9] rounded-lg shadow-sm px-4 py-3">
            <i class="fa-solid fa-triangle-exclamation text-[#6B7D8C] text-4xl"></i>
        </div>

        <div class="flex flex-col items-center justify-center text-center">
            <p class="text-[#4B5563] dark:text-textDark text-lg">You have unsaved changes.</p>
            <p class="text-[#4B5563] dark:text-textDark text-lg">If you leave this page now, your changes will be lost.</p>
            <p class="text-[#4B5563] dark:text-textDark text-lg">Do you want to continue without saving?</p>
        </div>

        <div class="flex flex-row items-center justify-center gap-x-4">
            <button (click)="leaveWithoutSaving()"
                class="bg-[#F6F7F9] text-[#4B5563] px-4 py-2 rounded-lg hover:bg-gray-200 flex flex-col items-center justify-center">
                <span class="font-semibold">Leave</span>
                <span>without saving</span>
            </button>

            <button (click)="stayOnPage()"
                class="bg-[#415CFF] text-white px-10 py-2 rounded-lg hover:bg-blue-600 flex flex-col items-center justify-center">
                <span class="font-semibold">Stay</span>
                <span>on page</span>
            </button>
        </div>
    </div>
</div>
